import { BarChartOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import styled from "styled-components";

export const ReportsWrapper = styled.div`
  padding: 20px;
`;

export const Flex = styled.div<{ justify?: string; align?: string; gap?: number }>`
  display: flex;
  justify-content: ${(props) => props.justify || "flex-start"};
  align-items: ${(props) => props.align || "flex-start"};
  gap: ${(props) => (props.gap ? `${props.gap}px` : "0")};
`;

export const FlexWrapper = styled(Flex)`
  gap: 6px;
  align-items: center;
  vertical-align: middle;

  @media (max-width: 620px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const InfoWrapper = styled(Flex)`
  gap: 8px;
  align-items: center;

  @media (max-width: 530px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const EditIcon = styled(EditOutlined)`
  font-size: 20px;
  cursor: pointer;
`;

export const InfoText = styled.div`
  span {
    font-size: 14px;
    color: #000;
  }

  span:first-child {
    color: #000;
  }
`;

export const Label = styled.span`
  text-wrap: nowrap;
  color: #000;
  font-size: 14px;
`;

export const ActionWrapper = styled(Flex)`
  gap: 12px;
  margin: 0;

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SelectWrapper = styled(Flex)`
  width: 100%;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledStatusWrapper = styled(Flex)`
  width: 100%;
  gap: 10px;
  gap: 8px;
  align-items: center;
  flex-wrap: nowrap;
`;

export const StyledBarChartIcon = styled(BarChartOutlined)`
  font-size: 20px;
  color: #545965;
`;

export const CloseOutlinedIcon = styled(CloseOutlined)`
  margin-left: 8px;
`;

export const StyledHeading = styled.h3`
  font-weight: 500;
  color: #545965;
  margin: 0;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const InfoTextWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const SelectContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const LostInfoText = styled.div`
  span {
    font-size: 14px;
    color: #000;
  }

  span:first-child {
    color: #000;
  }
`;

export const ReportedInfoText = styled.div`
  span {
    font-size: 14px;
    color: #000;
  }

  span:first-child {
    color: #000;
  }

  @media (max-width: 530px) {
    margin-top: 0px;
  }
`;

export const PenIconWrapper = styled.div`
  cursor: pointer;
  position: relative;
`;

export const DatePickerWrapper = styled.div`
  position: relative;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;

  @media (max-width: 792px) {
    gap: 10px;
    flex-direction: column;
    align-items: center;
  }
`;

export const ReasonFooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
`;


export const TrackingButton = styled(Button)`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  font-size: 14px;
  height: 40px;
  margin-right :22px;
`;

export const MarkedAsShippedContainer = styled.div`
  font-size: 16px;
  color: #000;
  flex-direction: column;
  display: flex;
  gap: 10px;
  margin: 20px 0;
`;

export const DownloadButton = styled(Button)`
  justify-content: flex-start;
  width: fit-content;
`;

export const UnlinkModalSubTitle = styled(Typography)`
  margin: 16px 0;
  font-size: 16px;
  color: #154075;
`;